import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Modal } from '../../../../shared/components';
import BasicRadioGroup from '../../../../shared/components/BasicRadioGroup';
import { BasicNotification } from '../../../../shared/components/Notification';
import { findMapId, findMapped } from '../../../../shared/misc/utils';

interface EsrrDeleteModalProps {
  visible: boolean;
  setVisible: React.Dispatch<React.SetStateAction<boolean>>;
  esrrId: number;
  callback: (idEsrr: number) => void;
}

const EsrrDeleteModal: React.FC<EsrrDeleteModalProps> = (props) => {
  const { esrrId, visible, setVisible, callback } = props;
  const { t } = useTranslation();

  const DELETE_LAP = 'delete-lap';

  const [deleteOption, setDeleteOption] = useState(DELETE_LAP);

  const deleteAction = (id: number) => {
    setVisible(false);
    callback(id);
  };

  const radioItems = [{ id: 2, text: t('deleteEsrr'), htmlId: 'radioLap', mapped: DELETE_LAP }];

  const setSelectedDeleteOption = (radId: number) => {
    const value = findMapped(radioItems, radId);
    setDeleteOption(value);
  };

  return (
    <Modal
      title={t('deleteDocuments')}
      visible={visible}
      setVisible={setVisible}
      actions={[
        { text: t('cancel'), action: () => setVisible(false) },
        { text: t('delete'), action: () => deleteAction(esrrId) },
      ]}
      onClosed={() => setVisible(false)}
      customClass="flow-delete-modal"
    >
      <>
        <div className="justify-content-left pl-2">
          <BasicRadioGroup
            name="select"
            elements={radioItems}
            onChange={setSelectedDeleteOption}
            value={findMapId(radioItems, deleteOption)}
            direction="vertical"
          />
        </div>
        <BasicNotification
          message={t('deleteEsrrMessageWarningRelated')}
          color="warning"
          icon="exclamation-triangle"
        />
      </>
    </Modal>
  );
};

export default EsrrDeleteModal;
